import {css, cx} from "@panda/css";

import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {BottomSheet, useBottomSheetState} from "@/components/bottom_sheet";
import {POPUP_PANEL_CLOSE_MS, PopupPanel} from "@/components/popup_panel";
import {useHomeMatchPreferencesSurvey} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {zIndexes} from "@/features/km_app/constants/z_indexes";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {useUserProfileData} from "@/features/user/hooks/use_user_profile_data";
import {getProfileAvatarUrl} from "@/features/user/utils/profile_picture";

import {IProfileMenuItem} from "../config/profile_menu_items";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {UserProfileMenuVariant} from "../types/UserProfileMenuVariant";
import {getProfileGreeting} from "../utils/get_profile_greeting";
import {logoutUser} from "../utils/logout_user";
import {PreferencesNavCta} from "./PreferencesNavCta";
import {UserProfileMenuItems} from "./UserProfileMenuItems";
import {UserProfileMenuTrigger} from "./UserProfileMenuTrigger";

interface IProps {
    className?: string;
    showPreferencesCta?: boolean;
    variant?: UserProfileMenuVariant;
}

export const UserProfileMenu = (props: IProps) => {
    const {className, variant = UserProfileMenuVariant.MOBILE, showPreferencesCta = variant !== UserProfileMenuVariant.DESKTOP} = props;

    const isMobileVariant = variant === UserProfileMenuVariant.MOBILE;

    const {logoutItem, preferencesItem, site} = useProfileMenuItems();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();
    const {userData} = useUserProfileData();
    const {close, isClosing, isEntering, isOpen, toggle} = useBottomSheetState({
        closeMs: isMobileVariant ? undefined : POPUP_PANEL_CLOSE_MS,
        onOpen: () => NavigationAmplitudeTracker.expandSettingsSection()
    });

    const trackSettingsItem = (item: IProfileMenuItem) => {
        NavigationAmplitudeTracker.selectSettingsSection({selectedTab: item.label});
    };

    const handleLogout = () => {
        trackSettingsItem(logoutItem);
        close();
        logoutUser({next: kmAppLink.site.baseWithParams({site})});
    };

    const handleMenuItemNavigate = (item: IProfileMenuItem) => {
        trackSettingsItem(item);
        close();
    };

    const handlePreferencesNavigate = (item: IProfileMenuItem) => {
        handleMenuItemNavigate(item);
        preferencesSurvey.open();
    };

    const preferencesCta = showPreferencesCta && kmFeatureFlagHomeMatch && preferencesItem && (
        <PreferencesNavCta dataTestId={preferencesItem.testId} label={preferencesItem.label} onNavigate={() => handlePreferencesNavigate(preferencesItem)} />
    );

    const isPanelVisible = !isMobileVariant && (isOpen || isClosing);

    return (
        <div className={cx(profileMenuWrapperStyle, className)}>
            <UserProfileMenuTrigger
                avatarSrc={getProfileAvatarUrl(userData)}
                greeting={getProfileGreeting(userData?.name)}
                isOpen={isOpen}
                onToggle={toggle}
                variant={variant}
            />

            {isMobileVariant && isOpen && (
                <BottomSheet
                    ariaLabel={NAVIGATION_LABELS.PROFILE_GREETING.SETTINGS_SUBTITLE}
                    dataTestId={KM_COMMON_TEST_IDS.PROFILE_MENU}
                    header={preferencesCta}
                    isClosing={isClosing}
                    isEntering={isEntering}
                    onClose={close}
                    role="navigation"
                    zIndex={zIndexes.navigationProfileMenu}
                >
                    <UserProfileMenuItems onLogout={handleLogout} onNavigate={handleMenuItemNavigate} />
                </BottomSheet>
            )}

            {isPanelVisible && (
                <PopupPanel
                    ariaLabel={NAVIGATION_LABELS.PROFILE_GREETING.SETTINGS_SUBTITLE}
                    className={profileMenuPanelPositionStyle}
                    dataTestId={KM_COMMON_TEST_IDS.PROFILE_MENU}
                    isClosing={isClosing}
                    isEntering={isEntering}
                    onClose={close}
                    role="navigation"
                    zIndex={zIndexes.navigationProfileMenu}
                >
                    <UserProfileMenuItems onLogout={handleLogout} onNavigate={handleMenuItemNavigate} preferencesCta={preferencesCta} />
                </PopupPanel>
            )}
        </div>
    );
};

const profileMenuWrapperStyle = css({
    flexShrink: 0,
    position: "relative"
});

const profileMenuPanelPositionStyle = css({
    bottom: "100%",
    left: "22.4rem",
    mb: 1,
    transformOrigin: "bottom left",
    width: "24rem"
});
import {css, cx} from "@panda/css";

import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {BottomSheet, useBottomSheetState} from "@/components/bottom_sheet";
import {POPUP_PANEL_CLOSE_MS, PopupPanel} from "@/components/popup_panel";
import {useHomeMatchPreferencesSurvey} from "@/features/home_match/providers/HomeMatchPreferencesSurveyProvider";
import {zIndexes} from "@/features/km_app/constants/z_indexes";
import {kmFeatureFlagHomeMatch} from "@/features/km_app/utils/read_environment_variables";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {useUserProfileData} from "@/features/user/hooks/use_user_profile_data";
import {getProfileAvatarUrl} from "@/features/user/utils/profile_picture";

import {IProfileMenuItem} from "../config/profile_menu_items";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {UserProfileMenuVariant} from "../types/UserProfileMenuVariant";
import {getProfileGreeting} from "../utils/get_profile_greeting";
import {logoutUser} from "../utils/logout_user";
import {PreferencesNavCta} from "./PreferencesNavCta";
import {UserProfileMenuItems} from "./UserProfileMenuItems";
import {UserProfileMenuTrigger} from "./UserProfileMenuTrigger";

interface IProps {
    className?: string;
    showPreferencesCta?: boolean;
    variant?: UserProfileMenuVariant;
}

export const UserProfileMenu = (props: IProps) => {
    const {className, variant = UserProfileMenuVariant.MOBILE, showPreferencesCta = variant !== UserProfileMenuVariant.DESKTOP} = props;

    const isMobileVariant = variant === UserProfileMenuVariant.MOBILE;

    const {logoutItem, preferencesItem, site} = useProfileMenuItems();
    const preferencesSurvey = useHomeMatchPreferencesSurvey();
    const {userData} = useUserProfileData();
    const {close, isClosing, isEntering, isOpen, toggle} = useBottomSheetState({
        closeMs: isMobileVariant ? undefined : POPUP_PANEL_CLOSE_MS,
        onOpen: () => NavigationAmplitudeTracker.expandSettingsSection()
    });

    const trackSettingsItem = (item: IProfileMenuItem) => {
        NavigationAmplitudeTracker.selectSettingsSection({selectedTab: item.label});
    };

    const handleLogout = () => {
        trackSettingsItem(logoutItem);
        close();
        logoutUser({next: kmAppLink.site.baseWithParams({site})});
    };

    const handleMenuItemNavigate = (item: IProfileMenuItem) => {
        trackSettingsItem(item);
        close();
    };

    const handlePreferencesNavigate = (item: IProfileMenuItem) => {
        handleMenuItemNavigate(item);
        preferencesSurvey.open();
    };

    const preferencesCta = showPreferencesCta && kmFeatureFlagHomeMatch && preferencesItem && (
        <PreferencesNavCta dataTestId={preferencesItem.testId} label={preferencesItem.label} onNavigate={() => handlePreferencesNavigate(preferencesItem)} />
    );

    const isPanelVisible = !isMobileVariant && (isOpen || isClosing);

    return (
        <div className={cx(profileMenuWrapperStyle, className)}>
            <UserProfileMenuTrigger
                avatarSrc={getProfileAvatarUrl(userData)}
                greeting={getProfileGreeting(userData?.name)}
                isOpen={isOpen}
                onToggle={toggle}
                variant={variant}
            />

            {isMobileVariant && isOpen && (
                <BottomSheet
                    ariaLabel={NAVIGATION_LABELS.PROFILE_GREETING.SETTINGS_SUBTITLE}
                    dataTestId={KM_COMMON_TEST_IDS.PROFILE_MENU}
                    header={preferencesCta}
                    isClosing={isClosing}
                    isEntering={isEntering}
                    onClose={close}
                    role="navigation"
                    zIndex={zIndexes.navigationProfileMenu}
                >
                    <UserProfileMenuItems onLogout={handleLogout} onNavigate={handleMenuItemNavigate} />
                </BottomSheet>
            )}

            {isPanelVisible && (
                <PopupPanel
                    ariaLabel={NAVIGATION_LABELS.PROFILE_GREETING.SETTINGS_SUBTITLE}
                    className={profileMenuPanelPositionStyle}
                    dataTestId={KM_COMMON_TEST_IDS.PROFILE_MENU}
                    isClosing={isClosing}
                    isEntering={isEntering}
                    onClose={close}
                    role="navigation"
                    zIndex={zIndexes.navigationProfileMenu}
                >
                    <UserProfileMenuItems onLogout={handleLogout} onNavigate={handleMenuItemNavigate} preferencesCta={preferencesCta} />
                </PopupPanel>
            )}
        </div>
    );
};

const profileMenuWrapperStyle = css({
    flexShrink: 0,
    position: "relative"
});

const profileMenuPanelPositionStyle = css({
    bottom: "100%",
    left: "22.4rem",
    mb: 1,
    transformOrigin: "bottom left",
    width: "24rem"
});
